import { ASSETS } from "@/lib/assets";
import ResponsibleBanner from "@/components/ResponsibleBanner";

export default function AboutPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14 space-y-10">
      <div className="text-center">
        <img src={ASSETS.hammerBadge} alt="Smasher hammer" className="w-28 mx-auto object-contain drop-shadow-[0_8px_24px_rgba(255,138,0,0.4)] mb-4" />
        <h1 className="font-heading font-black uppercase text-4xl sm:text-6xl text-gradient-gold">About Sportsbook Smasher</h1>
        <p className="text-smasher-gold font-bold tracking-widest mt-2 text-sm">CRUSH EVERY PLAY. SMASH EVERY BET.</p>
      </div>

      <div className="panel p-6 sm:p-8 space-y-4 text-slate-300 leading-relaxed">
        <p>Sportsbook Smasher isn't about blindly placing bets. It's about understanding the game, understanding the wager, doing the research, and making informed decisions.</p>
        <p>We combine sports information, upcoming events, recent scores, daily updates, and betting education into one high-energy platform. Our mission is to help you learn how sports wagers, odds, lines and strategy actually work.</p>
        <p>The Smasher hammer is our symbol — built to break odds, designed to represent discipline and research. But we never promise guaranteed wins. Betting always involves risk, and our focus is education and information, not financial advice.</p>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 text-center">
        {[["7", "Sports Covered"], ["Daily", "Updates"], ["100%", "Education First"]].map(([n, l]) => (
          <div key={l} className="panel p-5">
            <div className="font-heading font-black text-3xl text-gradient-gold">{n}</div>
            <div className="text-sm text-slate-400 mt-1">{l}</div>
          </div>
        ))}
      </div>

      <ResponsibleBanner />
    </div>
  );
}
